<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deptName" label="科室" v-if="getIsView()">
                <el-input disabled v-model="form.deptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>科室:{{ form.deptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="year" label="年度" v-if="getIsView()">
                <el-input disabled v-model="form.year"></el-input>
              </el-form-item>
              <span class="viewText" v-else>年度:{{ form.year }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" v-if="showCharge" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeAmount" label="年请领限额(计费)" v-if="getIsView()">
                <el-input disabled v-model="form.chargeAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>年请领限额(计费):{{ form.chargeAmount }} </span>
            </el-col>
            <el-col :span="6" v-if="showCharge" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeAmounted" label="本年度累计已领金额(计费)" v-if="getIsView()">
                <el-input disabled v-model="form.chargeAmounted"></el-input>
              </el-form-item>
              <span class="viewText" v-else>本年度累计已领金额(计费):{{ form.chargeAmounted }} </span>
            </el-col>
            <el-col :span="6" v-if="showNotCharge" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeAmount" label="年请领限额(不计费)" v-if="getIsView()">
                <el-input disabled v-model="form.notChargeAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>年请领限额(不计费):{{ form.notChargeAmount }} </span>
            </el-col>
            <el-col :span="6" v-if="showNotCharge" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="chargeAmounted" label="本年度累计已领金额(不计费)" v-if="getIsView()">
                <el-input disabled v-model="form.notChargeAmounted"></el-input>
              </el-form-item>
              <span class="viewText" v-else>本年度累计已领金额(不计费):{{ form.notChargeAmounted }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" ref="editCard" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">月度明细数据</span>
          </div>
          <div style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" :max-height="300" style="width: auto; margin: 0 10px" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" label="序号" width="50"> </el-table-column>
            <el-table-column prop="monthStr" label="期间" min-width="150"></el-table-column>
            <el-table-column v-if="showCharge" prop="chargeAmount" label="月请领限额(计费)" min-width="150"></el-table-column>
            <el-table-column v-if="showCharge" prop="chargeAmounted" label="本月累计已领金额(计费)" min-width="150"></el-table-column>
            <el-table-column v-if="showNotCharge" prop="notChargeAmount" label="月请领限额(不计费)" min-width="150"></el-table-column>
            <el-table-column v-if="showNotCharge" prop="notChargeAmounted" label="本月累计已领金额(不计费)" min-width="150"></el-table-column>
          </el-table>
        </div>

        <div v-if="showCharge" class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">计费产品请领进度图</span>
          </div>
          <div style="margin-top: 20px"></div>

          <div class="schedule-content" :style="{width:scheduleWidth+ 'px'}">
            <template v-for="(item, index) in chargeScheduleArr">
              <div :key="index" :style="{width:item.ratio + '%'}" class="div-schedule" :class="{'schedule-active': item.active,'border-right': index+1<chargeScheduleArr.length}">
                <el-popover placement="top-start" width="150" trigger="hover" :content="item.val + ''">
                  <div slot="reference">{{item.index}}</div>
                </el-popover>
              </div>
            </template>
          </div>
          <div class="schedule-content" :style="{width:realChargeWidth+ 'px'}">
            <div v-for="(item, index) in chargedScheduleArr" :key="index" :style="{width:item.ratio+'%'}" class="div-real" :class="{'real-active': item.active,'border-right': index+1<12}">
              <el-popover placement="top-start" width="150" trigger="hover" :content="item.val + ''">
                <div slot="reference">{{item.index}}</div>
              </el-popover>
            </div>
          </div>
        </div>

        <div v-if="showNotCharge" class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">不计费产品请领进度图</span>
          </div>
          <div style="margin-top: 20px"></div>

          <div class="schedule-content" :style="{width:scheduleWidth+ 'px'}">
            <div v-for="(item, index) in notChargeScheduleArr" :key="index" :style="{width:item.ratio+'%'}" class="div-schedule" :class="{'schedule-active': item.active,'border-right': index+1<notChargeScheduleArr.length}">
              <el-popover placement="top-start" width="150" trigger="hover" :content="item.val + ''">
                <div slot="reference">{{item.index}}</div>
              </el-popover>
            </div>
          </div>
          <div class="schedule-content" :style="{width:realNotChargeWidth+ 'px'}">
            <div v-for="(item, index) in notChargedScheduleArr" :key="index" :style="{width:item.ratio+'%'}" class="div-real" :class="{'real-active': item.active,'border-right': index+1<12}">
              <el-popover placement="top-start" width="150" trigger="hover" :content="item.val + ''">
                <div slot="reference">{{item.index}}</div>
              </el-popover>
            </div>
          </div>
        </div>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetDeptApplyQuotaUseById
} from "@/api";

export default {
  name: "DeptApplyQuotaUseEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  data () {
    return {
      GetDataAction: GetDeptApplyQuotaUseById,
      form: {},

      editMode: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,

      chargeScheduleArr: [],
      chargedScheduleArr: [],
      notChargeScheduleArr: [],
      notChargedScheduleArr: [],
      scheduleWidth: 1000,
      realChargeWidth: 1000,
      realNotChargeWidth: 1000,

      showCharge: false,
      showNotCharge: true,
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
  },
  mounted () {
    this.scheduleWidth = (this.$refs["editCard"].clientWidth * 0.8).toFixed() * 1
    this.realChargeWidth = this.scheduleWidth
    this.realNotChargeWidth = this.scheduleWidth
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.typeArr = this.form.type.split(';')
        this.form.typeArr = this.form.typeArr.map(e => {
          return e * 1
        })

        // console.log(this.form.typeArr)

        this.showCharge = Boolean(this.form.typeArr.find(e => e === 1))
        this.showNotCharge = Boolean(this.form.typeArr.find(e => e === 2))
        let month = new Date().getMonth() + 1
        let totalChargeAmounted = 0
        let totalNotChargeAmounted = 0
        this.form.details.forEach((e, index) => {
          totalChargeAmounted += e.chargeAmounted
          totalNotChargeAmounted += e.notChargeAmounted
          e.$index = index + 1;
          let chargeRatio = (e.chargeAmount * 100 / this.form.chargeAmount).toFixed(4) * 1
          let active = index + 1 <= month
          this.chargeScheduleArr.push({ ratio: chargeRatio, active: active, index: index + 1, val: e.chargeAmount })
          if (active) {
            let chargedRatio = (e.chargeAmounted * 100 / this.form.chargeAmount).toFixed(4) * 1
            if (chargedRatio > 0) {
              this.chargedScheduleArr.push({ ratio: chargedRatio, active: active, index: index + 1, val: e.chargeAmounted })
            }
          }

          let notChargeRatio = (e.notChargeAmount * 100 / this.form.notChargeAmount).toFixed(4) * 1
          this.notChargeScheduleArr.push({ ratio: notChargeRatio, active: active, index: index + 1, val: e.notChargeAmount })
          if (active) {
            let notChargedRatio = (e.notChargeAmounted * 100 / this.form.notChargeAmount).toFixed(4) * 1
            if (notChargedRatio > 0) {
              this.notChargedScheduleArr.push({ ratio: notChargedRatio, active: active, index: index + 1, val: e.notChargeAmounted })
            }
          }
        });

        if (totalChargeAmounted > this.form.chargeAmount) {
          this.realChargeWidth += 100
        }
        if (totalNotChargeAmounted > this.form.notChargeAmount) {
          this.realNotChargeWidth += 100
        }

        // this.initWorkFlowProperty(this.form);
      });
    },
    resetForm () {
      this.form = {
        "deptName": '',
        "year": '',
        "type": '',
        typeArr: [2],
        "details": [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.prevRoute.path == '/') {
        this.$router.go(-1)
      }
      else {
        this.routePushWithParams(this.prevRoute.path, this.$route.params);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}
/deep/ .el-table__fixed-header-wrapper {
  height: 100% !important;
}
/deep/ .el-table__fixed-body-wrapper {
  top: 52px !important;
}
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

::v-deep .el-table__fixed {
  // 左固定列
  height: auto !important;
  bottom: 12px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些,这个根据实际情况改
}

// ::v-deep .el-table__fixed-right {
//   // 右固定列
//   height: auto !important;
//   bottom: 12px;
// }

.schedule-content {
  display: flex;
  border: 1px solid #606266;
  height: 30px;
  // border-top: 1px solid #606266;
  // border-left: 1px solid #606266;
  // border-bottom: 1px solid #606266;
}
.div-schedule {
  text-align: center;
  line-height: 30px;
}
.schedule-active {
  background-color: #6bb86b;
}
.div-real {
  text-align: center;
  line-height: 30px;
}
.real-active {
  background-color: #e8aa35;
}

.border-right {
  border-right: 1px solid #606266;
}
</style>
